import request from '@/utils/request'

/**
 * 获取章节下的所有小节及资源
 */
export function listSectionsByChapter(chapterId, studentId) {
  return request({
    url: '/amc/chapter-section/list',
    method: 'get',
    params: { chapterId, studentId }
  })
}

/**
 * 获取小节详情（包含资源）
 */
export function getSectionDetail(id, studentId) {
  return request({
    url: `/amc/chapter-section/${id}`,
    method: 'get',
    params: { studentId }
  })
}

/**
 * 创建小节
 */
export function createSection(data) {
  return request({
    url: '/amc/chapter-section',
    method: 'post',
    data
  })
}

/**
 * 更新小节
 */
export function updateSection(id, data) {
  return request({
    url: `/amc/chapter-section/${id}`,
    method: 'put',
    data
  })
}

/**
 * 删除小节
 */
export function deleteSection(id) {
  return request({
    url: `/amc/chapter-section/${id}`,
    method: 'delete'
  })
}

/**
 * 添加资源到小节
 */
export function addResource(data) {
  return request({
    url: '/amc/chapter-section/resource',
    method: 'post',
    data
  })
}

/**
 * 删除资源
 */
export function deleteResource(id) {
  return request({
    url: `/amc/chapter-section/resource/${id}`,
    method: 'delete'
  })
}

export function getVideoOptimizeTask(taskId) {
  return request({
    url: `/file/videoOptimizeTask/${taskId}`,
    method: 'get'
  })
}

/**
 * 更新学习进度
 */
export function updateProgress(data) {
  return request({
    url: '/amc/chapter-section/progress',
    method: 'post',
    data
  })
}

/**
 * 标记小节为已完成
 */
export function markAsCompleted(studentId, sectionId) {
  return request({
    url: '/amc/chapter-section/progress/complete',
    method: 'post',
    params: { studentId, sectionId }
  })
}
